import { Grid, makeStyles } from '@material-ui/core';
import React from 'react';

import NoData from '../NoData/NoData';

const NoDataContainer: React.FC = () => {
  const classes = useStyles();

  return (
    <Grid
      className={classes.noDataContainer}
      container
      justify="center"
      alignItems="center"
      spacing={9}
    >
      <Grid item>
        <NoData />
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles(() => ({
  noDataContainer: {
    width: '100%',
    margin: 0,
  },
}));

export default NoDataContainer;
